import { render } from "./ImpressumSection.vue?vue&type=template&id=e8dc3d4a&scoped=true"
import script from "./ImpressumSection.vue?vue&type=script&lang=js"
export * from "./ImpressumSection.vue?vue&type=script&lang=js"

import "./ImpressumSection.vue?vue&type=style&index=0&id=e8dc3d4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8dc3d4a"]])

export default __exports__